/**
 * Shared config for CategoryStrip + CategoriesPage (services / deals).
 */
export const CATEGORY_STRIP_MODES = {
  services: {
    listingType: 'services',
    facetAttribute: 'publicData.categoryLevel2',
    algoliaIndexEnv: 'REACT_APP_ALGOLIA_SERVICE_INDEX',
    titleMessageId: 'CategoryStrip.servicesTitle',
    listingsCountMessageId: 'CategoryStrip.listingsCount',
    viewAllMessageId: 'CategoryStrip.viewAllCategories',
    searchParamKey: 'publicData.categoryLevel2',
    translationKeyPrefix: 'category',
    parentSearchPath: '/s/services',
    categoriesMode: 'services',
  },
  deals: {
    listingType: 'deals',
    facetAttribute: 'publicData.listingsCategories',
    algoliaIndexEnv: 'REACT_APP_ALGOLIA_DEALS_INDEX',
    titleMessageId: 'CategoryStrip.dealsTitle',
    listingsCountMessageId: 'CategoryStrip.listingsCount',
    viewAllMessageId: 'CategoryStrip.viewAllCategories',
    searchParamKey: 'publicData.listingsCategories',
    translationKeyPrefix: 'category',
    parentSearchPath: '/s/deals',
    categoriesMode: 'deals',
  },
};

export const getCategoryStripIndexName = modeConfig =>
  process.env[modeConfig.algoliaIndexEnv];
